The value of `Location.id` for the requested object.
